<template>
  <div class="error-view">
    <h1 class="error-view__code">{{code}}</h1>
    <h2 v-if="title"
        class="error-view__title">{{$tGlobal(title)}}</h2>
    <div v-if="computedMessage" class="error-view__text  text">
      <p>
        {{computedMessage}}
      </p>
    </div>
    <div class="error-view__footer">
      <router-link-modified :to="{name: 'home'}"
                            class="error-view__btn  base-btn  base-btn--blue">{{$tGlobal('Main')}}
      </router-link-modified>
      <router-link-modified :to="{name: 'site-map'}"
                            class="error-view__btn  base-btn  base-btn--blue">{{$tGlobal('Site map')}}
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  // import globalMetaMixin from '../mixins/globalMetaMixin'
  import {setMetaRobots} from '@/helpers/metaRobots'

  export default {
    // mixins: [globalMetaMixin],
    props: {
      code: {
        type: [String, Number],
        default: '404'
      },
      title: String,
      message: String,
      noSetMeta: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      computedMessage() {
        return this.message ||
            this.code.toString() === '404' ? this.$tGlobal('Perhaps you entered the wrong URL for the page') : null
      }
    },
    created() {
      if(this.noSetMeta) return

      if(this.code >= 400 && this.code < 500) {
        setMetaRobots('noindex, follow', this.code)
      }
    }
  }
</script>

<style scoped>

</style>
